/* tslint:disable */
/* eslint-disable */
/**
 * Optimizely Feature Experimentation API
 * This page documents how to use the Optimizely FX API. With this API you can view and manage Feature Flags and all of their related entities including Variables, Variations, Rules, and Reports.  The base URL is https://api.optimizely.com/flags/v1. Append any paths listed in these docs onto that url in order to make requests to the API.
 *
 * The version of the OpenAPI document: 0.3.7
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 *
 * @export
 * @interface VariableDefinition
 */
export interface VariableDefinition {
  /**
   * Unique string identifier for the Flag Variable Definition within the Flag
   * @type {string}
   * @memberof VariableDefinition
   */
  key: string;
  /**
   * The datatype for the Flag Variable Definition
   * @type {string}
   * @memberof VariableDefinition
   */
  type: VariableDefinitionTypeEnum;
  /**
   * The default value for the Flag Variable Definition
   * @type {string}
   * @memberof VariableDefinition
   */
  default_value: string;
  /**
   * Additional context of the Flag Variable Definition
   * @type {string}
   * @memberof VariableDefinition
   */
  description?: string;
  /**
   * Revision number for tracking changes
   * @type {number}
   * @memberof VariableDefinition
   */
  readonly revision?: number;
  /**
   * Granular permission role
   * @type {string}
   * @memberof VariableDefinition
   */
  readonly role?: string;
  /**
   * List of acceptable values that can be used for this variable when creating a variation.
   * @type {Array<string | number | boolean>}
   * @memberof VariableDefinition
   */
  non_default_acceptable_values?: Array<string | number | boolean>;
  /**
   * The type of acceptable value that is being passed. If the value is defined, then validation will be done against non_default_acceptable_values. If the value is range, (this is only for integer and double) validation will be done against max_acceptable_value and min_acceptable_value
   * @type {string}
   * @memberof VariableDefinition
   */
  acceptable_value_type?: VariableDefinitionAcceptableValueTypeEnum;
  /**
   * The maximum value for the default value and the variable value when creating a variation.
   * @type {number}
   * @memberof VariableDefinition
   */
  max_acceptable_value?: number;
  /**
   * The minimum value for the default value and the variable value when creating a variation.
   * @type {number}
   * @memberof VariableDefinition
   */
  min_acceptable_value?: number;
}

export function VariableDefinitionFromJSON(json: any): VariableDefinition {
  return VariableDefinitionFromJSONTyped(json, false);
}

export function VariableDefinitionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): VariableDefinition {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    key: json['key'],
    type: json['type'],
    default_value: json['default_value'],
    description: !exists(json, 'description') ? undefined : json['description'],
    revision: !exists(json, 'revision') ? undefined : json['revision'],
    role: !exists(json, 'role') ? undefined : json['role'],
    non_default_acceptable_values: !exists(
      json,
      'non_default_acceptable_values'
    )
      ? undefined
      : (json['non_default_acceptable_values'] as Array<
          string | number | boolean
        >),
    acceptable_value_type: !exists(json, 'acceptable_value_type')
      ? undefined
      : json['acceptable_value_type'],
    max_acceptable_value: !exists(json, 'max_acceptable_value')
      ? undefined
      : json['max_acceptable_value'],
    min_acceptable_value: !exists(json, 'min_acceptable_value')
      ? undefined
      : json['min_acceptable_value'],
  };
}

export function VariableDefinitionToJSON(
  value?: VariableDefinition | null
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    key: value.key,
    type: value.type,
    default_value: value.default_value,
    description: value.description,
    non_default_acceptable_values:
      value.non_default_acceptable_values === undefined
        ? undefined
        : (value.non_default_acceptable_values as Array<
            string | number | boolean
          >),
    acceptable_value_type: value.acceptable_value_type,
    max_acceptable_value: value.max_acceptable_value,
    min_acceptable_value: value.min_acceptable_value,
  };
}

/**
 * @export
 * @enum {string}
 */
export enum VariableDefinitionTypeEnum {
  Boolean = 'boolean',
  String = 'string',
  Double = 'double',
  Integer = 'integer',
  Json = 'json',
}
/**
 * @export
 * @enum {string}
 */
export enum VariableDefinitionAcceptableValueTypeEnum {
  Custom = 'custom',
  Defined = 'defined',
  Range = 'range',
}
